/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Button, Container, Drawer, Stack, Tooltip, Typography, useTheme } from '@mui/material';
import { useAtom } from 'jotai';
import { isMobile } from 'react-device-detect';

import useScreenSize from '../../../hooks/useScreenSize/useScreenSize';
import { showFilterAtom } from '../../../state/atoms/atoms';
import FiltersQuery from '../FiltersQuery/FiltersQuery';

function FiltersPane() {
  const [showfilters, setShowFilters] = useAtom(showFilterAtom);
  const screenSizes = useScreenSize();
  const [isMobileScreen, setIsMobileScreen] = useState(false);
  useEffect(() => {
    if (isMobile || screenSizes.width < 865) {
      setShowFilters(false);
      setIsMobileScreen(true);
    } else {
      setShowFilters(true);
      setIsMobileScreen(false);
    }
  }, [screenSizes.width]);
  const theme = useTheme();

  return (
    <>
      {!isMobileScreen && (
        <Stack
          sx={{
            border: `1px solid ${theme.palette.divider}`,
            height: '100%',
            width: '100%',
          }}
        >
          <Container sx={{ padding: '1rem', paddingBottom: '.5rem' }}>
            <Typography variant="h3" style={{ textTransform: 'uppercase' }}>
              Filters
            </Typography>
          </Container>
          <Container sx={{ padding: '1rem', paddingTop: '0rem' }}>
            <FiltersQuery isInitialSize={screenSizes.isInitialSize} />
          </Container>
        </Stack>
      )}
      {isMobileScreen && (
        <Drawer
          slotProps={{
            paper: {
              sx: {
                width: '100%',
              },
            },
          }}
          open={showfilters}
          onClose={() => setShowFilters(false)}
        >
          <Stack
            sx={{ padding: '1.5rem', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}
            direction="row"
          >
            <Typography variant="h3" style={{ textTransform: 'uppercase' }}>
              Filters
            </Typography>
            <Tooltip title="Close filters pane" arrow placement="top">
              <Button
                variant="text"
                color="inherit"
                startIcon={<CloseIcon />}
                aria-label="Close"
                onClick={() => setShowFilters(false)}
              />
            </Tooltip>
          </Stack>
          <Container sx={{ paddingX: '1.5rem', paddingBottom: '1.5rem' }}>
            <FiltersQuery isInitialSize={screenSizes.isInitialSize} />
          </Container>
        </Drawer>
      )}
    </>
  );
}
export default FiltersPane;
